import React, { useState } from 'react';
import './otaghNameBox.scss';

// نامِ فضا + (اختیاری) مساحتِ واقعی. اگر مساحت داده شود، آن فضا «ثابت» می‌شود و بقیه‌ی پلان (فقط فضاهایی که
// مساحتشان تخمینیِ برنامه است) برایش جا باز می‌کنند. خالی گذاشتن = برگشت به تخمین.
// estimate: مساحتِ فعلی (متر مربع) — راهنمای کاربر؛ initialArea: مساحتی که قبلاً خودش داده بود
const faNum = (n) => Number(n).toLocaleString('fa-IR', { maximumFractionDigits: 1 });
const toLatin = (s) =>
  String(s || '')
    .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
    .replace(/[٫,]/g, '.')
    .replace(/[^\d.]/g, '');
const toFa = (s) => String(s).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]).replace('.', '٫');

function OtaghNameBox({ x, y, initialName, initialArea, estimate, onConfirm, onCancel }) {
  const [value, setValue] = useState(initialName || '');
  const [area, setArea] = useState(initialArea ? String(initialArea) : '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const a = Number(area);
    onConfirm(value.trim() || 'بدون‌نام', a > 0.5 ? a : null);
  };

  return (
    <form className="otagh-name-box" style={{ left: x, top: y }} onSubmit={handleSubmit}>
      <input
        type="text"
        autoFocus={!initialName}
        placeholder="نام فضا (مثلاً اتاق خواب)"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <label className="otagh-name-box__area">
        <input
          type="text"
          inputMode="decimal"
          placeholder={estimate ? `حدود ${faNum(estimate)}` : 'مساحت'}
          value={toFa(area)}
          onChange={(e) => setArea(toLatin(e.target.value).slice(0, 6))}
        />
        <span>متر مربع</span>
      </label>
      <p className="otagh-name-box__hint">
        {area ? 'این فضا با همین مساحت ثابت می‌ماند و بقیه‌ی فضاها جا باز می‌کنند.' : 'اگر مساحتِ واقعی را می‌دانید بنویسید (اختیاری).'}
      </p>
      <div className="otagh-name-box__actions">
        <button type="button" onClick={onCancel}>انصراف</button>
        <button type="submit">تایید</button>
      </div>
    </form>
  );
}

export default OtaghNameBox;
